<template>
  <div class="flex flex-col mb-4 w-full">
    <div class="text-display1">{{ targetValue }}</div>
    <div v-if="progressText" class="text-medium">{{ progressText }}</div>
    <div v-else class="text-medium">
      {{ t("custom.challenge.target.label") }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
  targetValue: {
    type: [Number, String],
    required: true,
  },
  progressText: {
    type: String,
    required: true,
  },
});
</script>
